import { render, staticRenderFns } from "./ia-cliente-contatos.vue?vue&type=template&id=1d8efdec&scoped=true&"
import script from "./ia-cliente-contatos.vue?vue&type=script&lang=js&"
export * from "./ia-cliente-contatos.vue?vue&type=script&lang=js&"
import style0 from "./ia-cliente-contatos.vue?vue&type=style&index=0&id=1d8efdec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8efdec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8efdec')) {
      api.createRecord('1d8efdec', component.options)
    } else {
      api.reload('1d8efdec', component.options)
    }
    module.hot.accept("./ia-cliente-contatos.vue?vue&type=template&id=1d8efdec&scoped=true&", function () {
      api.rerender('1d8efdec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-cliente-painel/ia-cliente-contatos.vue"
export default component.exports